// src/plugins/fontawesome.js
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { 
  faTrash, 
  faEdit, 
  faSave, 
  faTimes, 
  faCopy, 
  faCheck, 
  faGear,
  faPlus,
  faMinus,
  faRotate
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faTrash,
  faEdit,
  faSave,
  faTimes,
  faCopy,
  faCheck,
  faGear,
  faPlus,
  faMinus,
  faRotate
)

export default FontAwesomeIcon